<template>
  <v-layout justify-center>
    <v-flex class="dashboard lg8 md10 sm12 ma-2"  >
       <v-layout wrap>
         <v-flex class="link">
           <router-link :to="{name: 'Items'}" >
             <img src="../../../static/images/icon8icons/icons8-paint-palette-50.png" /><br />
             Items
           </router-link>
         </v-flex>
         <v-flex class="link">
           <router-link :to="{name: 'Orders'}"  >
            <img src="../../../static/images/icon8icons/icons8-purchase-order-50.png" /><br />
             Orders
           </router-link>
         </v-flex>

         <v-flex class="link">
           <a :href="siteName">
            <img src="../../../static/images/icon8icons/icons8-online-store-50.png" /><br />
             My Store
           </a>
         </v-flex>

       </v-layout>
       <hr />

       <v-layout wrap>
         <v-flex class="link">
           <router-link :to="{name: 'Account'}" >
            <img src="../../../static/images/icon8icons/icons8-settings-50-2.png" /><br />
             Account Settings
           </router-link>
         </v-flex>
         <v-flex class="link">
           <router-link :to="{name: 'SiteSettings'}" >
            <img src="../../../static/images/icon8icons/icons8-globe-50-2.png" /><br />
             Site Settings
           </router-link>
         </v-flex>
         <v-flex class="link">
           <router-link :to="{name: 'SellerSettings'}" >
            <img src="../../../static/images/icon8icons/icons8-cat-profile-50.png" /><br />
             Seller Settings
           </router-link>
         </v-flex>
         <v-flex class="link">
           <router-link :to="{name: 'RecentActivity'}" >
            <img src="../../../static/images/icon8icons/icons8-todo-list-50.png" /><br />
             Recent Activity
           </router-link>
         </v-flex>
       </v-layout>
       <hr />

         <v-layout wrap >
           <v-flex class="link">
             <router-link :to="{name: 'Help'}" >
              <img src="../../../static/images/icon8icons/icons8-help-50.png" /><br />
               Help
             </router-link>
           </v-flex>
           <v-flex class="link">
             <a href="mailto:dan@smartkidsmarket.com?subject=SmartKidsMarket feedback about the site">
              <img src="../../../static/images/icon8icons/icons8-feedback-50.png" /><br />
               Feedback
             </a>
           </v-flex>

           <v-flex class="link" @click="logout" :style="myStyle" >
              <img src="../../../static/images/icon8icons/icons8-sign-out-50.png" /><br />
               Logout
           </v-flex>

       </v-layout>

     </v-flex>
   </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import {mapState} from 'vuex'
import config from '../../config.js'


export default {
  name: 'Dashboard',
  components: {

  },
  props: {

  },
  computed: {
    ...mapState({
      name: state => state.admin ? state.admin.userInfo.name : 'Loading...',
      parentToken: state => state.parent.parentToken,
      fontColor: state => state.themeInfo.fontColor,
      accentColor: state => state.themeInfo.colors.accent,
      siteName: state => {
        return config.serverLoc + state.admin.userInfo.aid
      },
    }),
    myStyle: function () {
      return `color: ${this.accentColor}; font-weight:bold;`
    }
  },

  watch: {

  },
  data () {
    return {
      categories: null,
      toggleMenu: true,
      // settingsItems: [
      //   {title: 'Account', icon: 'account_box', to: '/artists/account/'},
      //   {title: 'Site', icon: 'shop', to: '/artists/sitesettings/'},
      //   {title: 'Seller', icon: 'person', to: '/artists/seller/'}
      // ]
    }
  },
  mounted: function () {
  },
  methods: {

    backToParentPortal: async function () {
      if (!this.parentToken) {
        console.error('Error: Cannot go back to parent portal, no parent token.')
      } else {
        // Login as the parent and return to the parent portal
        // Now login with the token
        await firebase.auth().signInWithCustomToken(this.parentToken)

        // Go to the kid's main page
        this.$router.push({name: 'ParentPortal'})
      }
    },
    logout: function () {
      console.log("DEBUG: signout in Dash")
      firebase.auth().signOut().then(() => {
        this.$router.replace('/login')
      })
    },
    gotoCategories: function () {
      this.$router.push({path: '/artists/categories/'})
    },
    gotoItems: function () {
      console.log('GOTO ITEMS')
      this.$router.push({path: '/artists/items/'})
    },
    gotoProfile: function () {
      this.$router.push({path: '/artists/profile/'})
    },
    gotoOrders: function () {
      this.$router.push({path: '/artists/orders/'})
    },
    addEditCategory: function (data) {
      // console.log('ADD CAT DATA WAS: ' + JSON.stringify(data))
      this.$router.push({name: 'addeditcategory', params: data})
    },
    addEditItem: function (data) {
      // console.log('ADD ITEM DATA WAS: ' + JSON.stringify(data))
      this.$router.push({name: 'addedititem', params: data})
    },
    viewOrder: function (data) {
      console.log(data)
      this.$router.push({path: '/artists/vieworder/' + data.orderData.id})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.dashboard {

}
.link {
  margin: 10px;
  font-size: large;
}
</style>
